export default function(legends) {
    return {
        colors: ['#26a0fc', '#2de0c2', '#7d77ff', '#e91e63', '#331c81', '#80a4bf', '#e4c54c','#4c5de4', '#c34ce4','#4ce480', '#f480a8','#8175ac','#5424ff','#4d9466'],
        chart: {
          height: 350,
          type: "bar",
          stacked: true,
          stackType: '100%'
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'left', 
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          position: 'bottom',
          formatter: function (val) {
            return val.toFixed(0)+"%";
          },
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: legends, 
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val;
            },
          },
        },
        stroke: {
            show: true,
            width: 5,
            colors: ['transparent']
        },
      }
  }